import { createContext, useContext } from 'react';
import { tSyncConversationsContext } from './SyncConversations.types.ts';
import { initialState } from './SyncConversations.constants.ts';

export const SyncConversationsContext =
  createContext<tSyncConversationsContext>(initialState);

export function useSyncConversationsContext(): tSyncConversationsContext {
  return useContext(SyncConversationsContext);
}
